import React, { useEffect, useState } from "react";
import {
  Loading,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
} from "carbon-components-react";
import { toast } from "react-toastify";
import Card from "../../components/Card/Card";
import http from "../../http-common";

const tableHeaders = [
  { header: "Nome", key: "firstName" },
  { header: "Sobrenome", key: "lastName" },
  { header: "Nº Protótipos Atribuídos", key: "allocatedCount" },
  { header: "Nº Protótipos Pontuados", key: "scoredCount" },
];

const PrototypeJuryStatsPage = () => {
  const [stats, setStats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchData = async () => {
    try {
      const response = await http.get("/prototypes/jury-stats");
      const data = response.data.map((user) => ({
        id: String(user.id || user.username),
        firstName: user.firstName || "-",
        lastName: user.lastName || "-",
        allocatedCount: user.allocatedCount || 0,
        scoredCount: user.scoredCount || 0,
      }));
      setStats(data);
    } catch (error) {
      toast.error("Erro ao carregar estatísticas de pontuação");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Card title="Pontuação por Júri — Protótipos">
      <Loading
        active={isLoading}
        description="Active loading indicator"
        withOverlay={true}
      />

      <DataTable rows={stats} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader
                      {...getHeaderProps({ header })}
                      key={header.key}
                    >
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>{cell.value}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
    </Card>
  );
};

export default PrototypeJuryStatsPage;
